import { render, staticRenderFns } from "./LapidusDocuments.vue?vue&type=template&id=5cbc3030&"
import script from "./LapidusDocuments.vue?vue&type=script&lang=js&"
export * from "./LapidusDocuments.vue?vue&type=script&lang=js&"
import style0 from "./LapidusDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports